var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuestionMark = function SvgQuestionMark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1444_1684)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 27,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5554 47.1166C38.5554 47.9496 37.859 48.6249 36.9999 48.6249C36.1409 48.6249 35.4445 47.9496 35.4445 47.1166C35.4445 46.2837 36.1409 45.6084 36.9999 45.6084C37.859 45.6084 38.5554 46.2837 38.5554 47.1166Z",
    fill: "#FF5E6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4624 39.0351C38.9118 39.2809 38.5555 39.8194 38.5555 40.4063V41.0835C38.5555 41.9159 37.8602 42.5918 37 42.5918C36.1398 42.5918 35.4445 41.9159 35.4445 41.0835V40.4063C35.4445 38.6459 36.5115 37.0322 38.159 36.2945C39.7441 35.5872 40.8888 33.7091 40.8888 32.7875C40.8888 30.7092 39.1451 29.0168 37 29.0168C34.8549 29.0168 33.1112 30.7092 33.1112 32.7875C33.1112 33.6202 32.4156 34.296 31.5555 34.296C30.6953 34.296 30 33.6202 30 32.7875C30 29.0455 33.1405 26 37 26C40.8595 26 44 29.0455 44 32.7875C44 34.8255 42.1768 37.821 39.4624 39.0351V39.0351Z",
    fill: "#FF5E6D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1444_1684",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1444_1684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1444_1684",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/questionMark.0010cdf88ebc93c336732ff9444ae198.svg";